

export interface IRLSidepanelPreviewItemComparer {
    IsSameItem(previewItem: any, otherPreviewItem: any): boolean;
}

export class RLDefaultPreviewItemComparer implements IRLSidepanelPreviewItemComparer {
    public IsSameItem(previewItem: any, otherPreviewItem: any): boolean {

        if (('record' in previewItem) && ('id' in previewItem.record) && (previewItem.record.id != null)) {
            return previewItem.record.id === otherPreviewItem.record.id;
        }
        if ('id' in previewItem && (previewItem.id != null)) {
            return previewItem.id === otherPreviewItem.id;
        }

        throw "Class RLDefaultPreviewItemComparer is unable to compare preview items for equivalency, please use a compatible preview item comparer.";
    }
}

export class RLAssestAttachmentPreviewItemComparer implements IRLSidepanelPreviewItemComparer {
    public IsSameItem(previewItem: any, otherPreviewItem: any): boolean {
        //return previewItem.attachmentID === otherPreviewItem.attachmentID;  // NOTE: this doesn't quite work if we rotate an image / ID changes
        return (previewItem.fileName === otherPreviewItem.fileName)
            && (previewItem.attachmentTypeID === otherPreviewItem.attachmentTypeID)
            && (previewItem.label === otherPreviewItem.label);
    }
}

